import axios from "axios";
import { isNativeApp, push as nativePush, onNativeEvent } from "./nativeBridge";
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications`;
const INSTALL_KEY = "erimus_install_id";

export const installId = () => {
  let id = localStorage.getItem(INSTALL_KEY);
  if (!id) {
    id = `inst-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
    localStorage.setItem(INSTALL_KEY, id);
  }
  return id;
};

const client = axios.create({ baseURL: BASE, timeout: 20000 });

const authHeaders = () => {
  try {
    const session = JSON.parse(localStorage.getItem("erimus_apoio_auth"));
    return session?.access_token ? { Authorization: `Bearer ${session.access_token}` } : {};
  } catch {
    return {};
  }
};

/** Pede permissão ao sistema, obtém o token Expo e registra o dispositivo para o aplicativo informado. */
export const enablePush = async (app) => {
  if (!isNativeApp()) return { ok: false, reason: "web" };
  const result = await nativePush.enable();
  if (!result?.token) return { ok: false, reason: result?.reason || "denied" };
  await client.post(
    "/devices",
    { app, token: result.token, platform: result.platform || "ios", install_id: installId() },
    { headers: app === "apoio" ? authHeaders() : {} }
  );
  return { ok: true, token: result.token };
};

export const pushStatus = async () => (isNativeApp() ? await nativePush.status() : null);

export const setPushEnabled = async (app, token, enabled) =>
  client.post("/devices/preferences", { app, token, enabled }, { headers: app === "apoio" ? authHeaders() : {} });

export const unregisterPush = async (app, token) =>
  client.post("/devices/unregister", { app, token, enabled: false }, { headers: app === "apoio" ? authHeaders() : {} });

export const listNotifications = async (app) => {
  if (app === "apoio") {
    const { data } = await client.get("/apoio", { headers: authHeaders() });
    return data;
  }
  const { data } = await client.get("/saude", { params: { install_id: installId() } });
  return data;
};

export const markNotificationsRead = async (app, notificationId) =>
  client.post(
    "/read",
    { app, install_id: app === "apoio" ? undefined : installId(), notification_id: notificationId || undefined },
    { headers: app === "apoio" ? authHeaders() : {} }
  );

/** Token entregue espontaneamente pela casca nativa logo após a permissão do iOS. */
export const onNativeToken = (app, onRegistered) =>
  onNativeEvent("push:token", async (message) => {
    if (!message.token) return;
    try {
      await client.post(
        "/devices",
        { app, token: message.token, platform: message.platform || "ios", install_id: installId() },
        { headers: app === "apoio" ? authHeaders() : {} }
      );
      if (onRegistered) onRegistered(message.token);
    } catch {
      /* o registro é retentado na próxima abertura */
    }
  });

/** Toque na notificação: a casca nativa entrega apenas uma rota interna do próprio aplicativo. */
export const onNotificationOpen = (handler) =>
  onNativeEvent("push:open", (message) => {
    const route = typeof message.route === "string" ? message.route : "";
    if (/^\/(saude|apoio)(\/|\?|$)/.test(route)) handler(route);
  });
